import i18n from "i18next"
import Backend from "i18next-chained-backend"
import { initReactI18next } from "react-i18next"
// @ts-ignore
import i18nResources from "i18nResources";


i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    backend: {
      backends: i18nResources,
      backendOptions: [{
        defaultVersion: localStorage.getItem(
          process.env.CROWDIN_LOCAL_STORAGE_MANIFEST_TIMESTAMP || ""
        ),
      },
      {
        distributionHash: process.env.CROWDIN_DISTRIBUTION_HASH,
        distributionScope: process.env.CROWDIN_DISTRIBUTION_SCOPE,
      },],
    },
    fallbackLng: "en",
    debug: process.env.NODE_ENV !== "production",
    keySeparator: ".",
    lowerCaseLng: true,
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
  })

export default i18n
